<template>
  <div class="propertyManageList">
    <div class="filters">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-input clearable class="searchInput" v-model="input" :placeholder="$t('lang.pla_accountOrname')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.propertyManageListCheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="idNo" :label="$t('lang.lbl_duties_note')"></el-table-column>
        <el-table-column prop="mobile" :label="$t('lang.lbl_duties_mobile')">
          <template slot-scope="scope">{{scope.row.mobile | valueIsNull}}</template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width1"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.lab_configGroups')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      propertyManageListCheckbox: require('@/config/enum')
        .propertyManageListCheckbox // 是否隐藏复选框
    }
  },
  created() {
    setTimeout(() => {
    window.localStorage.setItem('wyform', '')
    window.localStorage.setItem('wysaveData', '')
    window.localStorage.setItem('wyradioSaveData', '')
    window.localStorage.setItem('wyauthoritySaveData', '')
    window.localStorage.setItem('wyrolesaveData', '')
    window.localStorage.setItem('wypermissionsaveData', '')
    window.localStorage.setItem('wyunitsaveData', '')
    window.localStorage.setItem('wyauthorityList', '')
    window.localStorage.setItem('wypermissionlist', '')
    window.localStorage.setItem('wyrolelist', '')
    }, 200)
    this.getTablelist()
  },
  methods: {
    
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 物业人员管理
    getTablelist() {
      let loading = this.$loading()
      this.$get(
        `/staffs?pageSize=${this.pageSize}&pageNo=${this.pageNo}&gardenId=${this.$store.getters.gardenId}&keyword=${this.input.trim()}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    edit(id) {
      // this.$router.push({ name: 'addpropertyManage', query: { id: id } })
			this.$router.push({ name: 'configHousekeepingArea', query: { id: id } })
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    }
  }
}
</script>

<style lang="scss">
.propertyManageList .filters .el-input__inner {
  width: 240px;
}
.propertyManageList .upload-demo {
  display: inline;
  padding-left: 20px;
}
</style>
